export default __webpack_public_path__ + "static/media/Plus.9c06f809.svg";